import { parseISO } from "date-fns";
import { GROUPS_ENDPOINT, PLAYERS_ENDPOINT } from "@/common/constants";
import { Classification } from "@/common/models/classification";
import { Group } from "@/common/models/group";
import {
  Player,
  PlayerRequest,
  PlayerResponse,
  PlayerRole,
  PlayerStatus,
} from "@/common/models/player";
import { User } from "@/common/models/user";
import axios from "@/common/services/axios";

const processPlayer = (raw: PlayerResponse): Player => ({
  id: raw.id,
  user: {
    id: raw.user.id,
    alias: raw.user.alias,
    avatar: raw.user.avatar,
  } as User,
  name: null,
  group: raw.group_id,
  roles: raw.roles.map((r) => r as unknown as PlayerRole),
  status: raw.status as unknown as PlayerStatus,
  classification: null as unknown as Classification,
  bets: [],
  created: parseISO(raw.created_at),
  updated: parseISO(raw.updated_at),
  createdBy: raw.created_by,
  updatedBy: raw.updated_by,
});

const processNewPlayer = (data: User[], group: Group): Partial<PlayerRequest>[] => {
  const player = {
    user_id: "",
    group_id: group.id,
  } as Partial<PlayerRequest>;
  const addPlayers = [] as Partial<PlayerRequest>[];
  data.forEach((element) => {
    player.user_id = element.id;
    addPlayers.push(player);
  });
  return addPlayers;
};

export const fetchGroupPlayers = async (group: Group): Promise<Player[]> => {
  const response = await axios.get<PlayerResponse[]>(`${GROUPS_ENDPOINT}/${group.id}/players`);
  return Array.isArray(response.data) ? response.data.map(processPlayer) : [];
};

export const createPlayer = async (players: User[], group: Group): Promise<any> => {
  try {
    const playerDTO = processNewPlayer(players, group);
    await axios.post(`${GROUPS_ENDPOINT}/${group.id}${PLAYERS_ENDPOINT}`, playerDTO);
  } catch (error) {
    console.error(error);
  }
};
